// extracted by mini-css-extract-plugin
export default {"tableCard":"TableCard_tableCard__zbAUj"};